import React, { useMemo, useState } from 'react';

const SIZE_MAP = {
  xs: 'w-6 h-6 text-[9px]',
  sm: 'w-8 h-8 text-[10px]',
  md: 'w-10 h-10 text-[11px]',
  lg: 'w-12 h-12 text-sm',
  xl: 'w-16 h-16 text-base',
};

const TONE_MAP = {
  slate: 'bg-slate-100 text-slate-600 border-slate-200',
  indigo: 'bg-indigo-50 text-indigo-600 border-indigo-200',
  emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cyan: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  white: 'bg-white text-slate-700 border-slate-200',
  dark: 'bg-slate-900 text-white border-slate-800',
};

const buildInitials = ({ firstName = '', lastName = '', fullName = '' }) => {
  const first = String(firstName || '').trim();
  const last = String(lastName || '').trim();

  if (first || last) {
    return `${first?.[0] || '?'}${last?.[0] || '?'}`.toLocaleUpperCase();
  }

  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '??';
  if (parts.length === 1) return `${parts[0][0] || '?'}${parts[0][1] || '?'}`.toLocaleUpperCase();
  return `${parts[0][0] || '?'}${parts[parts.length - 1][0] || '?'}`.toLocaleUpperCase();
};

const EmployeeAvatar = ({
  firstName,
  lastName,
  fullName,
  photoUrl,
  profilePhotoUrl,
  size = 'md',
  tone = 'slate',
  rounded = 'rounded-full',
  className = '',
  title,
  alt,
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  const initials = useMemo(
    () => buildInitials({ firstName, lastName, fullName }),
    [firstName, lastName, fullName]
  );

  const resolvedPhoto = !imageFailed ? (photoUrl || profilePhotoUrl || '') : '';
  const sizeClass = SIZE_MAP[size] || SIZE_MAP.md;
  const toneClass = TONE_MAP[tone] || TONE_MAP.slate;

  return (
    <div
      title={title || fullName || `${firstName || ''} ${lastName || ''}`.trim()}
      className={`${sizeClass} ${rounded} overflow-hidden border flex items-center justify-center font-black uppercase shrink-0 shadow-sm ${resolvedPhoto ? 'bg-white border-slate-200' : toneClass} ${className}`.trim()}
    >
      {resolvedPhoto ? (
        <img
          src={resolvedPhoto}
          alt={alt || fullName || `${firstName || ''} ${lastName || ''}`.trim() || 'employee-avatar'}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span dir="ltr">{initials}</span>
      )}
    </div>
  );
};

export default EmployeeAvatar;
